export default () => {
    $(function() {
        var topPos = $("#sidebar .holder").offset().top;
        $(window).scroll(function() {
            //var widthPos = $('#sidebar .holder').width();
            //console.log(widthPos);
            var top = $(document).scrollTop(),
                pip = $("footer").offset().top;
            let height = $("#sidebar .holder").outerHeight();
            if (top > topPos && top < pip - height) {
                $("#sidebar .holder")
                    .addClass("fixed")
                    .removeAttr("style");
            } else if (top > pip - height) {
                $("#sidebar .holder")
                    .removeClass("fixed")
                    .css({ position: "absolute", bottom: "0" });
            } else {
                $("#sidebar .holder").removeClass("fixed");
            }
            //$('#sidebar .holder').width(widthPos);
        });
    });
};
